import React, { useContext } from 'react';
import DisabledOrPrivateInfo from '../../../../lego/DisabledOrPrivateInfo';
import { CommentEditorContext } from '../../../../../CommentEditor/context';
const CantPostView = ()=>{
    const { commentableItemId, commentableType } = useContext(CommentEditorContext);
    return /*#__PURE__*/ React.createElement(DisabledOrPrivateInfo, {
        commentableItemId: commentableItemId,
        commentableType: commentableType
    });
};
CantPostView.displayName = 'CantPostView';
export default CantPostView;

//# sourceMappingURL=CantPostView.js.map